export default {
  styleOverrides: {
    paper: { borderRadius: '5px' }
  }
};
